import { Breadcrumbs, Anchor, Text } from "@mantine/core";
import { IconChevronRight } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import useBreadcrumbs from "../../hooks/useBreadcrumbs";

const BreadcrumbNav = () => {
  const crumbs = useBreadcrumbs();
  const navigate = useNavigate();

  if (crumbs.length === 0) return null;

  return (
    <div className="px-4 py-2" style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
      <Breadcrumbs
        separator={<IconChevronRight size={16} stroke={1.5} />}
      >
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          if (isLast || !crumb.path) {
            return (
              <Text key={index} size="sm" fw={500} c="dimmed">
                {crumb.label}
              </Text>
            );
          }
          return (
            <Anchor
              key={index}
              size="sm"
              fw={500}
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                navigate(crumb.path!);
              }}
              style={{ cursor: "pointer" }}
            >
              {crumb.label}
            </Anchor>
          );
        })}
      </Breadcrumbs>
    </div>
  );
};

export default BreadcrumbNav;
